export default "__VITE_ASSET__ln_s7N0Q__"